$m(document).on("change","input[name='Add Personalization:']",function(){
	  var label= $m(this).parents(".product-form__input").find(".form__label").text().trim();
      	if(label== "Add Personalization:: No"){
		   var val=$m(this).val();
			if (val.toLowerCase().indexOf("yes") >= 0) {
			   $m(".line-item-property__field").show();
               $m(".line-item-property__field input").prop('required',true);
			}
			else if(val.toLowerCase().indexOf("no") >= 0){
		       $m(".line-item-property__field").hide();
               $m(".line-item-property__field input").prop('required',false);
               $m(".line-item-property__field input").removeAttr('required');
			}
        } else {
          $m(".line-item-property__field").show();
          $m(".line-item-property__field input").prop('required',true);
        }
	});

	$m(document).ready(function(){
	   var label= $m("input[name='Add Personalization:']").parents(".product-form__input").find(".form__label").text().trim();
      	if(label== "Add Personalization:: No"){
            var val=$m("input[name='Add Personalization:']").val();
            if (val.toLowerCase().indexOf("yes") >= 0) {
			   $m(".line-item-property__field").show();
               $m(".line-item-property__field input").prop('required',true);
			}
			else if(val.toLowerCase().indexOf("no") >= 0){
		       $m(".line-item-property__field").hide();
               $m(".line-item-property__field input").prop('required',false);
               $m(".line-item-property__field input").removeAttr('required');
			}
        } else {
          $m(".line-item-property__field").show();
          $m(".line-item-property__field input").prop('required',true);
        }
	});